module.exports = __webpack_public_path__ + "static/media/badge_premium_big.acded691.svg";